<app-loading *ngIf="contentReady"></app-loading>

<div class="vcash-change-password-page" style="margin-bottom: 90px;">

  <!-- TOP HEADER -->
  <section class="vcash-top">
    <div class="vcash-appbar">
      <a class="appbar-btn" routerLink="/Profile">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </a>

      <h1 class="appbar-title">{{ "Change Password" | transloco }}</h1>

      <div class="appbar-btn appbar-btn--ghost" routerLink="/notifications">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="vcash-content">

    <!-- SUMMARY CARD -->
    <section class="password-summary-card">
      <div class="password-summary-left">
        <span class="password-overline">{{ "Security" | transloco }}</span>
        <h2>{{ "Set New Password" | transloco }}</h2>
        <p>{{ "Update your password to keep your account secure" | transloco }}</p>
      </div>

      <div class="password-summary-icon">
        <img src="/assets/e-commerce/icons/51.webp" alt="password">
      </div>
    </section>

    <!-- FORM CARD -->
    <section class="form-card">
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">

        <div class="hero-icon">
          <img src="/assets/e-commerce/icons/51.webp" alt="password icon" />
        </div>

        <h2 class="logintext">{{ "Set New Password" | transloco }}</h2>

        <div class="field">
          <label for="oldPassword">{{ "Old Password" | transloco }}</label>
          <input class="form-control" id="oldPassword" [type]="isPasswordVisible ? 'text' : 'password'"
            formControlName="old_password" [placeholder]="'Old Password' | transloco" [ngClass]="{
              'is-invalid': changePasswordForm.controls['old_password'].touched && changePasswordForm.controls['old_password'].errors,
              'is-valid': changePasswordForm.controls['old_password'].touched && !changePasswordForm.controls['old_password'].errors,
              'is-touched': changePasswordForm.controls['old_password'].untouched && !changePasswordForm.controls['old_password'].errors
            }" />
        </div>

        <div class="field">
          <label for="Password">{{ "Password" | transloco }}</label>
          <input class="form-control" id="Password" [type]="isPasswordVisible ? 'text' : 'password'"
            formControlName="new_password" [placeholder]="'Password' | transloco" [ngClass]="{
              'is-invalid': changePasswordForm.controls['new_password'].touched && changePasswordForm.controls['new_password'].errors,
              'is-valid': changePasswordForm.controls['new_password'].touched && !changePasswordForm.controls['new_password'].errors,
              'is-touched': changePasswordForm.controls['new_password'].untouched && !changePasswordForm.controls['new_password'].errors
            }" />
        </div>

        <div class="field password-field">
          <label for="confirmPassword">{{ "Confirm Password" | transloco }}</label>
          <input class="form-control" id="confirmPassword" [type]="isPasswordVisible ? 'text' : 'password'"
            formControlName="new_password_confirmation" [placeholder]="'Confirm Password' | transloco" [ngClass]="{
              'is-invalid': changePasswordForm.controls['new_password_confirmation'].touched && changePasswordForm.controls['new_password_confirmation'].errors,
              'is-valid': changePasswordForm.controls['new_password_confirmation'].touched && !changePasswordForm.controls['new_password_confirmation'].errors,
              'is-touched': changePasswordForm.controls['new_password_confirmation'].untouched && !changePasswordForm.controls['new_password_confirmation'].errors
            }" />

          <button type="button" class="hidePasswordBtn" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){
            {{ "Show Password" | transloco }}
            } @else {
            {{ "Hide Password" | transloco }}
            }
          </button>
        </div>

        <button type="submit" class="submit-btn login">
          {{ "Send" | transloco }}
        </button>
      </form>
    </section>

  </div>
</div>